export const GET_ORDER_HISTORY_REQUEST = "GET_ORDER_HISTORY_REQUEST";
export const GET_ORDER_HISTORY_SUCCESS = "GET_ORDER_HISTORY_SUCCESS";
export const GET_ORDER_HISTORY_FAIL = "GET_ORDER_HISTORY_FAIL";

export const GET_ORDER_HISTORY_DETAIL_FAIL = "GET_ORDER_HISTORY_DETAIL_FAIL";
export const GET_ORDER_HISTORY_DETAIL_REQUEST =
  "GET_ORDER_HISTORY_DETAIL_REQUEST";
export const GET_ORDER_HISTORY_DETAIL_SUCCESS =
  "GET_ORDER_HISTORY_DETAIL_SUCCESS";
